var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { IsEnvRequired, RequiredAstrix, TemplateEnvDescription, TemplateInfoContent, TemplateInfoSectionHeader, } from '../styles';
import InputRenderer from '../../InputRenderer';
import { useDispatch, useSelector } from 'react-redux';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { editEnvironmentData, setEnvStatus, } from '@project/store/createAppFlow/actions';
import { selectEnvironments } from '@project/store/environment/selectors';
var EnvInput = function (_a) {
    var _b;
    var input = _a.input;
    var fieldName = input.key;
    var fieldType = input.type;
    var isRequired = input.required;
    var dispatch = useDispatch();
    var isValid = useRef(true);
    var _c = useSelector(selectAppCreationFlow), environmentData = _c.environmentData, createdTemplateApp = _c.createdTemplateApp;
    var files = useSelector(selectEnvironments).files;
    var extractValue = function (input) {
        var extractedValue = input.value.value ? input.value.value : input.value;
        if ((input === null || input === void 0 ? void 0 : input.type) === 'text' || (input === null || input === void 0 ? void 0 : input.type) === 'url') {
            if (typeof extractedValue === 'object') {
                return '';
            }
            else {
                return extractedValue;
            }
        }
        else if ((input === null || input === void 0 ? void 0 : input.type) === 'image' || (input === null || input === void 0 ? void 0 : input.type) === 'file') {
            if (typeof extractedValue === 'object') {
                return '';
            }
            else {
                return extractedValue;
            }
        }
        else if ((input === null || input === void 0 ? void 0 : input.type) === 'timestamp' || (input === null || input === void 0 ? void 0 : input.type) === 'time') {
            if (typeof extractedValue !== 'string') {
                return null;
            }
            else {
                return extractedValue;
            }
        }
        else if ((input === null || input === void 0 ? void 0 : input.type) === 'number') {
            if (typeof extractedValue !== 'number') {
                return null;
            }
            else {
                return extractedValue;
            }
        }
        else {
            return extractedValue;
        }
    };
    var _d = useState((_b = {},
        _b[fieldName] = extractValue(input),
        _b)), value = _d[0], setValue = _d[1];
    var _e = useState(null), isNumberValid = _e[0], setIsNumberValid = _e[1];
    var index = _.findIndex(environmentData, function (obj) {
        return (obj === null || obj === void 0 ? void 0 : obj.id) === (input === null || input === void 0 ? void 0 : input.id);
    });
    useEffect(function () {
        dispatch(editEnvironmentData(index, value, fieldName, fieldType));
        if (isRequired) {
            if ((fieldType === 'number' && isNumberValid) ||
                value[fieldName] === '' ||
                value[fieldName] === undefined ||
                value[fieldName] === null) {
                isValid.current = false;
                dispatch(setEnvStatus(true));
            }
            else {
                isValid.current = true;
                dispatch(setEnvStatus(false));
            }
        }
    }, [dispatch, index, value, fieldName, isRequired, fieldType, isNumberValid]);
    return (_jsx(_Fragment, { children: _jsxs(TemplateInfoContent, __assign({ subSection: true }, { children: [_jsxs(TemplateInfoSectionHeader, { children: [input === null || input === void 0 ? void 0 : input.label, " ", (input === null || input === void 0 ? void 0 : input.required) && _jsx(RequiredAstrix, { children: "*" })] }), _jsx(TemplateEnvDescription, { children: input.description }), _jsx(InputRenderer, { field: {
                        type: input === null || input === void 0 ? void 0 : input.type,
                        name: input === null || input === void 0 ? void 0 : input.key,
                    }, files: files, sendObject: value, setSendObject: setValue, fullWidth: true, appCreationAppId: createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.id, setIsNumberEmpty: setIsNumberValid }), !isValid.current && (_jsx(IsEnvRequired, { children: "Missing information. Please fill out this field to proceed." }))] }), input === null || input === void 0 ? void 0 : input.id) }));
};
export default EnvInput;
